import React from 'react'
import { shallow, mount } from 'enzyme'
import columnWidthsToFr from '../features/dashboard/helpers/columnWidthsTofr'
import { formatPercentageOfCap, formatPortfolioSize, formatAverageSmartRate, formatLeftUntilCap, formatRole, formatName } from '../features/dashboard/helpers/formatters'

describe('helpers', () => {
  describe('columnWidthsToFr', () => {
    it('should append \'fr\' to each element of a provided array of numbers', () => {
      const columnsWidths = [2, 4, 5, 9]
      const fr = columnWidthsToFr(columnsWidths)
      for (const [index, value] of fr.split(' ').entries()) {
        expect(value).toEqual(`${columnsWidths[index]}fr`)
      }
    })
  })
  describe('formatters', () => {
    let genieSettings, admin
    describe('formatName', () => {
      describe('when there are no genie settings present', () => {
        beforeEach(() => {
          admin = {
            shortTermThrottled: false,
            name: 'Admin',
            genieSettings: undefined,
            link: 'http://google.com'
          }
        })
        it('should render the admin\'s name', () => {
          const formattedName = mount(formatName(admin)).text()
          expect(formattedName).toEqual(admin.name)
        })
        it('should render a link to the admin\'s detail page', () => {
          const mountedName = mount(formatName(admin))
          expect(mountedName.find('a').at(0).props().href).toEqual(admin.link)
        })
        it('should render a rocket ship if the admin is short term throttled', () => {
          admin.shortTermThrottled = true
          const mountedName = mount(formatName(admin))
          expect(mountedName.find('i').props().className).toContain('fa fa-rocket')
        })
      })
      describe('when there are genie settings present', () => {
        beforeEach(() => {
          admin = {
            shortTermThrottled: false,
            name: 'Admin',
            genieSettings: {
              outOfOffice: false
            },
            link: 'http://google.com'
          }
        })
        it('should render the admin\'s name', () => {
          const formattedName = mount(formatName(admin)).text()
          expect(formattedName).toEqual(admin.name)
        })
        it('should render a link to the admin\'s detail page', () => {
          const mountedName = mount(formatName(admin))
          expect(mountedName.find('a').at(0).props().href).toEqual(admin.link)
        })
        it('should render a rocket ship if the admin is short term throttled', () => {
          admin.shortTermThrottled = true
          const mountedName = mount(formatName(admin))
          expect(mountedName.find('i').props().className).toContain('fa fa-rocket')
        })
        it('should render the words `Out of Office` if the admin is set to out of office', () => {
          admin.genieSettings.outOfOffice = true
          const formattedName = mount(formatName(admin)).text()
          expect(formattedName).toContain('(Out of Office)')
        })
      })
    })
    describe('formatRole', () => {
      beforeEach(() => {
        genieSettings = {
          level: 'Senior',
          preferredLenders: ['First Home', 'Five Star'],
          preferredPartners: ['Fundera', 'Credit Karma']
        }
      })
      it('should render a comma-separated list of the admin\'s preferred lenders', () => {
        const formattedRole = mount(<div>{formatRole(genieSettings)}</div>).text() // Enzyme cannot render fragments so we wrap it in a div
        expect(formattedRole).toContain(genieSettings.preferredLenders.join(', '))
      })
      it('should render a comma-separated list of the admin\'s preferred partners', () => {
        const formattedRole = mount(<div>{formatRole(genieSettings)}</div>).text()
        expect(formattedRole).toContain(genieSettings.preferredPartners.join(', '))
      })
      it('should render the admin\'s level', () => {
        const formattedRole = mount(<div>{formatRole(genieSettings)}</div>).text()
        expect(formattedRole).toContain(genieSettings.level)
      })
    })
    describe('formatLeftUntilCap', () => {
      it('should append `left` to its input if it is greater than zero', () => {
        const wrapper = mount(formatLeftUntilCap(20))
        expect(wrapper.text()).toEqual('20 left')
      })
      it('should append take the absolute value of and append `over` to its input if it is less than zero', () => {
        const wrapper = mount(formatLeftUntilCap(-2))
        expect(wrapper.text()).toEqual('2 over')
      })
      it('should render a zero if it is given a zero', () => {
        const wrapper = mount(formatLeftUntilCap(0))
        expect(wrapper.text()).toEqual('0')
      })
    })
    describe('formatPercentageOfCap', () => {
      it('should multiply its input by 100, round it to an integer, and add a percent sign', () => {
        const percentageOfCap = 0.236
        const formattedPercentage = formatPercentageOfCap(percentageOfCap)
        expect(formattedPercentage).toEqual('24%')
      })
    })
    describe('formatPortfolioSize', () => {
      it('should divide its input by 1,000,000 and truncate it to two decimal places', () => {
        const portfolioSize = 20223000
        const formattedPortfolioSize = formatPortfolioSize(portfolioSize)
        expect(formattedPortfolioSize).toEqual('20.22')
      })
    })
    describe('formatAverageSmartRate', () => {
      it('should truncate its input to one decimal place', () => {
        const averageSmartRate = 2.44444
        const formattedAverageSmartRate = formatAverageSmartRate(averageSmartRate)
        expect(formattedAverageSmartRate).toEqual('2.4')
      })
    })
  })
})
